export default "__VITE_ASSET__BaSa8biC__"